export var _emptyParameters = Object.freeze([]);
var _invalidParameters = Object.freeze([
    Function,
    Object,
    String,
    RegExp,
    Number,
    Boolean,
    Array,
    Promise,
]);
var Invalid = /** @class */ (function () {
    function Invalid(container, key) {
        this.container = container;
        this.key = key;
        if (container instanceof Function) {
            this.container = container.name;
        }
        if (key instanceof Function) {
            this.key = key.name;
        }
    }
    return Invalid;
}());
export function clearInvalidParameters(container, inject) {
    var _loop_1 = function (i) {
        if (_invalidParameters.some(function (z) { return z === inject[i]; })) {
            inject[i] = new Invalid(container, inject[i]);
        }
    };
    for (var i = 0; i < inject.length; i++) {
        _loop_1(i);
    }
    return inject;
}
export function validateKey(key) {
    if (key === null || key === undefined) {
        throw new Error(
        // tslint:disable-next-line:max-line-length
        "key/value cannot be null or undefined. Are you trying to inject/register something that doesn't exist with DI?");
    }
    if (key instanceof Invalid) {
        throw new Error("Invalid key found on " + key.container + " looking for type " + key.key + ".  Are you trying to inject/register something that doesn't exist with DI?");
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmFsaWRhdGVQYXJhbWV0ZXJzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsidmFsaWRhdGVQYXJhbWV0ZXJzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLE1BQU0sQ0FBQyxJQUFNLGdCQUFnQixHQUFHLE1BQU0sQ0FBQyxNQUFNLENBQU0sRUFBRSxDQUFDLENBQUM7QUFDdkQsSUFBTSxrQkFBa0IsR0FBRyxNQUFNLENBQUMsTUFBTSxDQUFNO0lBQzFDLFFBQVE7SUFDUixNQUFNO0lBQ04sTUFBTTtJQUNOLE1BQU07SUFDTixNQUFNO0lBQ04sT0FBTztJQUNQLEtBQUs7SUFDTCxPQUFPO0NBQ1YsQ0FBQyxDQUFDO0FBQ0g7SUFDSSxpQkFBMEIsU0FBYyxFQUFTLEdBQVE7UUFBL0IsY0FBUyxHQUFULFNBQVMsQ0FBSztRQUFTLFFBQUcsR0FBSCxHQUFHLENBQUs7UUFDckQsSUFBSSxTQUFTLFlBQVksUUFBUSxFQUFFO1lBQy9CLElBQUksQ0FBQyxTQUFTLEdBQUcsU0FBUyxDQUFDLElBQUksQ0FBQztTQUNuQztRQUNELElBQUksR0FBRyxZQUFZLFFBQVEsRUFBRTtZQUN6QixJQUFJLENBQUMsR0FBRyxHQUFHLEdBQUcsQ0FBQyxJQUFJLENBQUM7U0FDdkI7SUFDTCxDQUFDO0lBQ0wsY0FBQztBQUFELENBQUMsQUFURCxJQVNDO0FBQ0QsTUFBTSxVQUFVLHNCQUFzQixDQUFDLFNBQWMsRUFBRSxNQUFhOzRCQUN2RCxDQUFDO1FBQ04sSUFBSSxrQkFBa0IsQ0FBQyxJQUFJLENBQUMsVUFBQyxDQUFDLElBQUssT0FBQSxDQUFDLEtBQUssTUFBTSxDQUFDLENBQUMsQ0FBQyxFQUFmLENBQWUsQ0FBQyxFQUFFO1lBQ2pELE1BQU0sQ0FBQyxDQUFDLENBQUMsR0FBRyxJQUFJLE9BQU8sQ0FBQyxTQUFTLEVBQUUsTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUM7U0FDakQ7O0lBSEwsS0FBSyxJQUFJLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxHQUFHLE1BQU0sQ0FBQyxNQUFNLEVBQUUsQ0FBQyxFQUFFO2dCQUE3QixDQUFDO0tBSVQ7SUFDRCxPQUFPLE1BQU0sQ0FBQztBQUNsQixDQUFDO0FBRUQsTUFBTSxVQUFVLFdBQVcsQ0FBQyxHQUFhO0lBQ3JDLElBQUksR0FBRyxLQUFLLElBQUksSUFBSSxHQUFHLEtBQUssU0FBUyxFQUFFO1FBQ25DLE1BQU0sSUFBSSxLQUFLO1FBQ1gsMkNBQTJDO1FBQzNDLGdIQUFnSCxDQUNuSCxDQUFDO0tBQ0w7SUFDRCxJQUFJLEdBQUcsWUFBWSxPQUFPLEVBQUU7UUFDeEIsTUFBTSxJQUFJLEtBQUssQ0FDWCwwQkFBd0IsR0FBRyxDQUFDLFNBQVMsMEJBQXFCLEdBQUcsQ0FBQyxHQUFHLCtFQUE0RSxDQUNoSixDQUFDO0tBQ0w7QUFDTCxDQUFDIn0=